import {Base} from "@/api/Base"

export class InsuranceCompanyListAll extends Base {
    path = "insuranceCompany/listAll"
}